import React, { CSSProperties } from 'react';

import { Icon, Space } from '@sravni/react-design-system';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import { useStyles } from '@sravni/react-utils';

import { TIP_TEXTS } from './texts';
import styles from './tips.module.scss';

export const Tips: React.FC = () => {
  const cx = useStyles(styles);

  return (
    <Space className={cx('tips')} size={16}>
      {TIP_TEXTS.map(({ iconComponent, title, text, iconColor }, i) => {
        const bgColor = `var(--color-${iconColor[0].toUpperCase()}06)`;

        return (
          <div className={cx('tip')} style={{ '--bg-color': bgColor } as CSSProperties} key={[title, i].join('-')}>
            <Icon
              color={iconColor}
              icon={iconComponent}
              background={iconColor}
              size={16}
              shape={'round'}
              variant={'primary'}
            >
              {iconComponent}
            </Icon>

            <Heading level={5} className={'h-mt-12'}>
              {title}
            </Heading>
            <Text size={12} className={'h-mt-2'}>
              {text}
            </Text>
          </div>
        );
      })}
    </Space>
  );
};
